<template>
  <b-modal
      id="xero-400-modal"
      ref="xero-400-modal"
      size="lg-size"
      modal-class="modal-xero"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
      hide-header
      @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">Unable to export timesheets!</h2>
      <div class="quickbooks-logo">
        <img
            src="/assets/images/xero-logo-blue.svg"
            alt="Atto"
            class="black-logo"
            width="50"
            height="50"
        >
      </div>
    </div>
    <div class="content-wrapper">
      <p>
        A timesheet for the same period already exists in your Xero account. To export your timesheet data from Atto, first delete the timesheet in Xero and then re-export.
      </p>
      <span v-if="errorMessage" class="error-message">
                {{ errorMessage }}
            </span>
    </div>
    <div class="modal-footer">
      <button
          type="reset"
          class="atto-btn cancel"
          data-dismiss="modal"
          @click="close"
      >
        {{ label.get('cancel') }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import CompanyService from "../services/CompanyService";

export default {
  name: "XeroUk400ErrorModal",
  data() {
    return {
      errorMessage: '',

    }
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$store.commit('showLoading');
    this.$refs['xero-400-modal'].show();
    this.$store.commit('hideLoading');
  },
  methods: {
    close() {
      debugger;
      this.$root.$emit('hideXeroUk400ErrorModal');
    }
  }
}
</script>

<style lang="scss" scoped>


</style>